<template>
    <div id="sign_in">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>防封域名配置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <div class="el-card-button">
                <el-button type="primary" size="small" @click="addRecharge">添加防封域名</el-button>
            </div>
            <div>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="domain"
                            label="防封域名">
                    </el-table-column>
                    <el-table-column
                            prop="cname"
                            label="CNAME">
                    </el-table-column>
                    <el-table-column
                            prop="title"
                            label="状态">
                        <template slot-scope="scope">
                            <el-switch
                                    @change="switchChange(scope.row)"
                                    v-model="scope.row.status"
                                    :active-value="1"
                                    :inactive-value="0">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            label="创建时间">
                    </el-table-column>
                    <el-table-column
                            width="100"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="danger" plain size="small" @click="getareaDelete(scope.row.id)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </el-card>
        <!--            新增或编辑-->
        <el-dialog :title="fromTitle"
                   :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'90%':'50%'"
                   :visible.sync="visible">
            <el-form ref="form"
                     :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'70px':'150px'"
                     size="small">
                <el-form-item label="防封域名">
                    <el-input v-model="form.domain"
                              :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    </el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-select v-model="form.status" placeholder="请选择启用状态" style="width: 100%">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
        </el-dialog>
    </div>
</template>

<script>

  export default {
    name: "sign_in",
    data() {
      return {
        form: {
          domain: '',
          status: ''
        },
        tableData: [],
        visible: false,
        fromTitle: '',
        id: '',
        h5_domain:'',
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.$axios.get('mch/mch_domain').then((res) => {
          this.tableData = res.data.list;
        });
      },
      dialogClose() {
        this.visible = false
      },
      addRecharge() {
        this.fromTitle = '新增';
        this.form = {
          domain: '',
          status: ''
        };
        this.id = '';
        this.visible = true;
      },
      // 删除
      getareaDelete(id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.del("mch/mch_domain/" + id)
            .then(res => {
              this.$message.success('删除成功!');
              this.getData();
            })
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },
      dialogAffirm() {
        this.$axios.post('mch/mch_domain', this.form).then((res) => {
          this.$message.success('成功');
          this.getData();
          this.visible = false
        });
      },
      switchChange(row) {
        this.$axios.post('mch/mch_domain/set_status', {id: row.id, status: row.status}).then((res) => {
          this.$message.success('成功');
          this.getData();
        });
      }
    }
  }
</script>

<style scoped>

</style>